import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        readMore: '[js-read-more="opener"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.readMore)) {
            return
        }

        initReadMore()
    }

    function initReadMore() {
        $(nodeSelectors.readMore).on('click', function(){
            $(this).css('display', 'none');
            $(this).parent().find('.right-content').slideDown();
        })
    }

    return Object.freeze({
        init,
    })
}